import React, { createContext, useCallback, useContext, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import ImportantToast from "./important-toast";

const BackdropContext = createContext(null);

export function useBackdrop() {
  return useContext(BackdropContext);
}

export const BackdropProvider = ({ children }) => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [backdropMessage, setBackdropMessage] = useState("");

  const openBackdrop = useCallback((message) => {
    setBackdropMessage(message);
    setBackdropOpen(true);
  }, []);

  const closeBackdrop = useCallback(() => {
    setBackdropOpen(false);
    setBackdropMessage("");
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <BackdropContext.Provider value={{ openBackdrop, closeBackdrop }}>
      {children}
      <Backdrop
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
        }}
        open={backdropOpen}
      >
        <Box />
      </Backdrop>
      <ImportantToast
        isOpen={!backdropOpen}
        onClose={closeBackdrop}
        onAction={handleRefresh}
        message={backdropMessage}
        actionButtonText="Refresh"
        delay={0}
      />
    </BackdropContext.Provider>
  );
};
